/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentModel } from '@core/models';

const serverUri = 'https://raven.bitvarklab.com/api';
const demoDatasetId = '64d60a18fd159b0644379fff';

export const environment: EnvironmentModel = {
  production: true,
  locale: 'it-IT',
  envCode: 'prod',
  accountCode: 'BIB',
  appCode: 'cqs',
  flowCode: 'standalone',
  baseUrl: `${serverUri}/public/64c7be226cff71fd021943db/bib-self-revolving`,
  apiBaseUrl: `${serverUri}/public/64c7be226cff71fd021943db/bib-self-revolving`,
  securityBaseUrl: `${serverUri}/public/64c7be226cff71fd021943db/bib-self-revolving`,
  devMode: false,
  demoDatasetId
};
